<template>
  <div style="width: 1200px; margin: 0 auto; background-color: #f2f6fc">
    <Title :title="{ name: '请假申请', path: '/item/leave' }"></Title>

    <el-card class="box-card" style="min-height: 650px; margin-top: 15px">
      <el-form
        ref="leaveForm"
        :model="leaveForm"
        :rules="leaveRules"
        label-position="left"
        label-width="150px"
      >
        <el-divider content-position="left">请假信息</el-divider>
        <el-form-item prop="ccUserId" label-width="150px" label="抄送人员">
          <el-select
            v-model="leaveForm.ccUserId"
            placeholder="请选择抄送人员"
            multiple
            filterable
          >
            <el-option
              v-for="item in allSysUser"
              :key="item.userId"
              :label="item.realName"
              :value="item.userId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="leaveType" label-width="150px" label="请假类型" required>
          <el-radio-group v-model="leaveForm.leaveType">
            <el-radio :label="1">事假</el-radio>
            <el-radio :label="2">婚假</el-radio>
            <el-radio :label="3">丧假</el-radio>
            <el-radio :label="4">病假</el-radio>
            <el-tooltip class="item" effect="dark" :content="`剩余年假${surplusDaya}天/总共${totalDays}天`" placement="top">
              <el-radio :disabled="surplusDaya==0" :label="5">年假</el-radio>
            </el-tooltip>
            <el-radio :label="6">产假</el-radio>
            <el-radio :label="7">其他</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="leaveTimes" label-width="150px" label="请假时间">
          <el-date-picker
            @change="clear"
            v-model="leaveForm.leaveBegainTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="pickerOptions"
            :default-time="'23:59:59'"
            placeholder="开始时间"
          >
          </el-date-picker>
          <span style="margin: 0px 8px">至</span>
          <el-date-picker
            :readonly="endDisabled"
            @focus="dis"
            v-model="leaveForm.leaveEndTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="endtimeOption"
            placeholder="结束时间"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item prop="leaveSubject" label-width="150px" label="请假事由">
          <el-input
            type="textarea"
            rows="5"
            maxlength="300"
            show-word-limit
            v-model="leaveForm.leaveSubject"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button v-if="submitShow" type="primary" @click="newLeaveApply"
            >提交申请</el-button
          >
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import moment from "moment";
import Title from "../../Title";
import { annualLeave } from "@/util/helper";
import { AesDecrypt } from "@/util";
import {
  requestLeaveApply,
  requestUserGet,
  requestApplyDetail,
  requestGetAnnualLeave
} from "../../../api";
export default {
  name: "LeaveApply",
  components: { Title },
  data() {
    let disabledDate = (time) => {
      return time.getTime() < Date.now() - 8.64e7;
    };
    return {
      totalDays: "",
      surplusDaya: "1",
      endDisabled: true,
      applyId: "",
      applyServiceId: "",
      applyType: "",
      leaveId: null,
      reapply: false,
      submitShow: true,
      allSysUser: null,
      leaveForm: {
        ccUserId: null,
        leaveType: 1,
        leaveBegainTime: null,
        leaveEndTime: null,
        leaveTimes: null,
        leaveSubject: null,
      },
      leaveRules: {
        leaveTimes: [
          { required: true, message: "请填写请假时间", trigger: "blur" },
        ],
        leaveSubject: [
          { required: true, message: "请填写请假事由", trigger: "blur" },
          {
            min: 2,
            max: 300,
            message: "长度在 2 到 300 个字符",
            trigger: "change",
          },
        ],
      },
      pickerOptions: {
        disabledDate,
        selectableRange: [],
      },
      endtimeOption: {},
    };
  },
  watch: {
    "leaveForm.leaveBegainTime"(n) {
      this.endDisabled = !n;
      this.selectable();
    },
    "leaveForm.leaveEndTime"() {
      // 如果选择的结束时间不是当天，重置可以选择的时间
      const date = moment(this.leaveForm.leaveEndTime)
        .startOf("day")
        .format("x");
      const nowDate = moment(this.leaveForm.leaveBegainTime)
        .startOf("day")
        .format("x");
      const h = this.leaveForm.leaveBegainTime.split(" ")[1];
      // 如果选择的是今天 则需要禁用已经过去的时间节点
      if (date <= nowDate) {
        this.endtimeOption.selectableRange = `${h} - 23:59:59`;
      } else {
        this.endtimeOption.selectableRange = "00:00:00 - 23:59:59";
      }
      let arr = [];
      arr[0] = this.leaveForm.leaveBegainTime;
      arr[1] = this.leaveForm.leaveEndTime;
      this.leaveForm.leaveTimes = arr;
    },
  },
  methods: {
    clear() {
      this.leaveForm.leaveEndTime = "";
    },
    dis() {
      if (this.leaveForm.leaveBegainTime) {
        const h = this.leaveForm.leaveBegainTime.split(" ")[1];
        let form = this.leaveForm;
        this.endtimeOption = {
          disabledDate: function (time) {
            return (
              time.getTime() < moment(form.leaveBegainTime).valueOf() - 8.64e7
            );
          },
          selectableRange: `${h} - 23:59:59`,
        };
      }
    },
    newLeaveApply() {
      this.$refs["leaveForm"].validate((isPass) => {
        if (isPass) {
          this.leaveForm.ccUserId = this.leaveForm.ccUserId.join(",");
          this.leaveForm.leaveTimes = null;
          this.submitShow = false;
          // 重新申请需要的参数
          if (this.reapply) {
            this.leaveForm.leaveId = this.leaveId;
            this.leaveForm.applyId = this.applyId;
            this.leaveForm.reapply = this.reapply;
          }
          requestLeaveApply(this.leaveForm).then((res) => {
            if (res.code === 200) {
              this.$message.success(res.msg);
              // 重新申请完之后清空路径参数
              if (this.reapply) {
                this.$router.push({ query: {} });
                this.reapply = false;
              }
              this.resetForm();
              this.leaveForm.leaveBegainTime = "";
              this.leaveForm.leaveEndTime = "";
              this.submitShow = true;
            } else {
              this.$message.error(res.msg);
              this.submitShow = true;
            }
          });
        }
      });
    },
    async loadSysUserData() {
      let res = await requestUserGet();
      if (res.code == 200) {
        this.allSysUser = res.object;
      } else {
        this.$message.error("获取人员列表失败");
      }
    },
    getObject() {
      requestApplyDetail({
        applyId: this.applyId,
        applyServiceId: this.applyServiceId,
        applyType: this.applyType,
      }).then((res) => {
        if (res.code == 200) {
          if (res.object) {
            let detail = res.object.detail;
            this.leaveId = detail.leaveId;
            this.leaveForm.ccUserId = (detail.ccUserId || '').split(',').filter(id => id && !isNaN(parseInt(id))).map(id => parseInt(id));
            this.leaveForm.leaveBegainTime = detail.leaveBegainTime;
            this.leaveForm.leaveEndTime = detail.leaveEndTime;
            this.leaveForm.leaveSubject = detail.leaveSubject;
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    resetForm() {
      this.$refs["leaveForm"].resetFields();
    },
    selectable() {
      // 禁用今天的时间以及修改结束时间不能小于开始时间
      const date = moment(this.leaveForm.leaveBegainTime)
        .startOf("day")
        .format("x");
      const nowDate = moment().startOf("day").format("x");
      // 如果选择的是今天 则需要禁用已经过去的时间节点
      if (date <= nowDate) {
        this.pickerOptions.selectableRange = `${moment()
          .add(1, "minutes")
          .format("HH:mm:ss")} - 23:59:59`;
      } else {
        this.pickerOptions.selectableRange = "00:00:00 - 23:59:59";
      }
    },
    async getAnnualLeave() {
      const res = await requestGetAnnualLeave()
      if (res.code === 200) {
        this.surplusDaya = this.totalDays - res.object.days
      }
    }
  },
  created() {
    let data = AesDecrypt(window.localStorage.getItem("user"));
    this.user = JSON.parse(data);
    this.totalDays = annualLeave(this.user.entryTime)
    this.getAnnualLeave()
    this.applyId = this.$route.query.applyId;
    this.applyServiceId = this.$route.query.applyServiceId;
    this.applyType = this.$route.query.applyType;
    if (this.applyId || this.applyServiceId || this.applyType) {
      this.reapply = true;
      this.getObject();
    }
    this.loadSysUserData();
  },
};
</script>

<style scoped></style>
